/*
 * Copyright (c) 2023 Trimble Inc. All rights reserved.
 */

export function saveToLocalStorage(state: any, stateName: string) {
    try{
        const serializedState = JSON.stringify(state);
        localStorage.setItem(stateName, serializedState);
    } catch(e){
        console.log(e);
    }
}

export function loadFromLocalStorage(stateName : string){
    try{
        const serializedState = localStorage.getItem(stateName);
        if(serializedState === null) {
            return undefined;
        }
        return JSON.parse(serializedState);
    } catch(e){
        console.log(e);
        return undefined;
    }
}

export function checkLocalStorageExpiry(){
    //DELETE THIS METHOD.

    // var hours = 9.75; // Reset when storage is more than 9 hours
    // var now = new Date().getTime();
    // var setupTime = localStorage.getItem('Expiration');
    // if (setupTime == null) {
    //     localStorage.setItem('Expiration', now.toString())
    // } else {
    //     if(now-(+setupTime) > hours*60*60*1000) {
    //         localStorage.clear()
    //         localStorage.setItem('Expiration', now.toString());
    //     }
    // }
}

export function clearLocalStorageItem(name: string) {
  if (localStorage.getItem(name) != null) {
    localStorage.removeItem(name);
  }
}
